export const usingGiftsData = {
  Gifts: {
    Title: "Gifts",
    GeneralTopData: [],
    GeneralBottomData: [],
    Steps: [
      {
        StepTitle: "What Are Gifts?",
        Description: [
          "Show Your Support: Gifts are virtual items you can send to your favourite streamers during live events. They are a way to show appreciation and support while interacting with the streamer.",
        ],
      },
      {
        StepTitle: "Purchasing Gifts",
        Description: [
          "Use Tokens: Gifts are bought using tokens. During a live stream, select the gift icon, choose the gift you want to send, and confirm the token expenditure.",
        ],
      },
      {
        StepTitle: "Sending Gifts",
        Description: [
          "How to Send: While watching a stream, click on the gift icon, select your desired gift, and click 'Send.' The gift will appear in the stream, and the streamer will be notified of your support.",
        ],
      },
      {
        StepTitle: "Types of Gifts",
        Description: [
          "Variety of Options: There are various types of gifts available, each with a different token value. Choose from simple icons, animations, or special event-themed gifts.",
        ],
      },
      {
        StepTitle: "Gift Leaderboards",
        Description: [
          "Top Supporters: Some streams may feature leaderboards showing the top gift givers. Sending gifts can increase your visibility and status within the community.",
        ],
      },
      {
        StepTitle: "All or Nothing Arena",
        Description: [
          "High-Stakes Gifting: In some events, all gifts may go to the winning streamer. If Players choose this option, your gift will only be received if your chosen streamer wins the challenge.",
        ],
      },
    ],
  },
};
